// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d68260e7","541":"05de3d85","703":"2f24daee"}[chunkId] + ".chunk.js";
};